import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class Returned extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.Returned;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { returnedBy, returnedAt } = fragment;
        gameContext.setFieldPosition(returnedAt);
        gameContext.setCurrentPlayerInPossession(returnedBy);
        gameContext.setPossessionForTeamId(returnedBy?.teamId);
    }
}
